'use client';

import { useAtom } from 'jotai/react';
import { useSignInOnClick } from 'src/hooks/useSignInOnClick';
import { useSignOutOnClick } from 'src/hooks/useSignOutOnClick';
import { sidebarAtom } from 'src/services/state/atoms/sidebar';
import { useSession } from 'src/services/state/providers/SessionProvider';

import { useTranslations } from 'next-intl';
import { useEffect } from 'react';

import CustomLink from './CustomLink';
import Icon from './Icon';
import SiteLogo from './SiteLogo';

const Sidebar = () => {
  const session = useSession();
  const t = useTranslations('components.Header');
  const signInOnClick = useSignInOnClick();
  const signOutOnClick = useSignOutOnClick();

  const [sidebar, setSidebar] = useAtom(sidebarAtom);

  useEffect(() => {
    document.body.classList.toggle('sidebar-open', sidebar.visible);
  }, [sidebar.visible]);

  return (
    <aside
      id="mobile-sidebar"
      data-testid="mobile-sidebar"
      className={(sidebar.visible ? 'visible' : 'hidden') + ' ma__header__hamburger__nav-container'}
      aria-hidden={!sidebar.visible}
      onClick={() => setSidebar((prev) => ({ ...prev, visible: false }))}
    >
      <div className="ma__header_slim ma__header__hamburger__logo--mobile">
        <div className="ma__site-logo">
          <SiteLogo
            url="/"
            image={{
              src: `${process.env.NEXT_PUBLIC_BASE_PATH}/img/logo.png`,
              alt: t('happle_alt'),
              width: 45,
              height: 45,
            }}
            siteName={t('title')}
            linkAriaLabel={t('site_logo_mobile_aria_label')}
          />
        </div>
      </div>

      <div className="ma__header__hamburger__main-nav">{/* Main navigation items would go here */}</div>

      <div className="ma__header__hamburger__utility-nav ma__header__hamburger__utility-nav--narrow js-utility-nav--narrow">
        <div className="ma__utility-nav js-util-nav">
          <ul className="ma__utility-nav__items usa-list--unstyled">
            <li className="ma__utility-nav__item">
              <CustomLink
                button
                href="/documents"
                className="width-auto  margin-left-2"
                inversed
                variation="unstyled"
                aria-label={t('navigation_link_mobile_aria_label', { label: t('nav_link_my_documents') })}
              >
                <Icon name="folder_open" className="margin-right-05 position-relative text-middle" size={3} />
                {t('nav_link_my_documents')}
              </CustomLink>
            </li>
            {/*<!-- Add other links here, above login/logout button -->*/}
            <li className="ma__utility-nav__item">
              <CustomLink
                button
                href="#"
                onClick={session ? signOutOnClick : signInOnClick}
                className="width-auto  margin-left-2"
                inversed
                variation="unstyled"
                aria-label={t('navigation_link_mobile_aria_label', {
                  label: t(session ? 'nav_link_signout' : 'nav_link_signin'),
                })}
              >
                <Icon
                  name={session ? 'logout' : 'login'}
                  className="margin-right-05 position-relative text-middle"
                  size={3}
                />
                {t(session ? 'nav_link_signout' : 'nav_link_signin')}
              </CustomLink>
            </li>
          </ul>
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
